import { Visit, VisitStatus } from '@curebase/core/types';

const { NotEligible } = VisitStatus;

export default function isDataCaptureNotEligible<
  V extends Pick<Visit, 'status'>
>(v: V): boolean {
  return [NotEligible].includes(v.status);
}
